
    import { defineComponent, onBeforeMount, ref } from 'vue'
    import { useRoute } from 'vue-router/composables'

    import GdprModal from '@/app/components/GdprModal.vue'
    import PageFooter from '@/common/components/footer/PageFooter.vue'
    import PageHeader from '@/app/components/header/PageHeader.vue'
    import PageLoader from '@/app/components/PageLoader.vue'
    import Sidebar from '@/app/components/Sidebar.vue'

    import { useGtag } from '@/common/composables/libs/gtag'

    import { useCategoriesStore } from '@/app/stores/categories'
    import { useGdprStore } from '@/app/stores/gdpr'
    import { useScheduleStore } from '@/app/stores/schedule'
    import { useSharedSettingsStore } from '@/common/stores/shared-settings'
    import { useSidebarStore } from '@/app/stores/sidebar'
    import { useUsersStore } from '@/app/stores/users'

    export default defineComponent({
        components: {
            GdprModal,
            PageFooter,
            PageHeader,
            PageLoader,
            Sidebar
        },
        setup () {
            const gtag = useGtag()
            const route = useRoute()
            const gdprStore = useGdprStore()

            const gdprDialogShown = ref(false)
            const loading = ref(true)

            const checkSidebarForceShowFlags = (): void => {
                const sidebarStore = useSidebarStore()

                // DO NOT change this conditions to assignment.
                // These are only to check force showing chat or player
                // by using url params.
                if (route.query.player === '1') {
                    sidebarStore.playerShown = true
                }

                if (route.query.chat === '1') {
                    sidebarStore.chatShown = true
                }
            }

            const init = async (): Promise<void> => {
                await useCategoriesStore().load()
                await useSharedSettingsStore().load()
                await useScheduleStore().load()
                await useUsersStore().load()

                // Enable tracking if GDPR is accepted
                if (gdprStore.accepted) {
                    gtag.optIn()
                }

                // If user has not specified GDPR status show the modal
                if (gdprStore.notChosen) {
                    gdprDialogShown.value = true
                }

                loading.value = false
            }

            onBeforeMount(async () => {
                await init()
                checkSidebarForceShowFlags()
            })

            return {
                gdprDialogShown,
                loading
            }
        }
    })
